/*
  Order Free Samples — behaviour for snippets/samples.liquid.
  - Opens/closes the self-contained modal.
  - Adds a sample variant to the cart using the theme's native flow
    (fetchConfig + routes.cart_add_url + cart.renderContents), no FoxKit.
  - Optional free-sample cap (data-sample-limit on the modal; 0 = disabled).
  - Dims a product's own free sample once it's already in the cart.
  Self-guards: does nothing on pages without a samples modal.
*/
(function () {
  var MODAL_ID = 'wo-samples-modal';
  var getModal = function () { return document.getElementById(MODAL_ID); };
  var cartUrl = function () { return (window.routes && routes.cart_url) || '/cart'; };
  // Free-sample cap (0 = disabled). Exposed globally so it also works on the cart
  // page, where there is no samples modal to read data-sample-limit from.
  var sampleLimit = function () {
    if (window.freeSampleLimit != null) return parseInt(window.freeSampleLimit, 10) || 0;
    var m = getModal();
    return parseInt((m && m.dataset.sampleLimit) || '0', 10) || 0;
  };
  var isFreeSample = function (i) { return (i.sku || '').indexOf('SAMP-') !== -1 && i.price === 0; };

  function openModal() {
    var m = getModal();
    if (!m) return;
    m.hidden = false;
    document.body.classList.add('samples-modal-open');
    if (typeof trapFocus === 'function') trapFocus(m);
  }
  function closeModal() {
    var m = getModal();
    if (!m || m.hidden) return;
    m.hidden = true;
    document.body.classList.remove('samples-modal-open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(m);
  }
  function showError(el, msg) {
    if (el) { el.textContent = msg; el.hidden = false; } else { alert(msg); }
  }

  // Delegated: works regardless of when the buttons enter the DOM.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-samples-open]')) { e.preventDefault(); openModal(); return; }
    if (e.target.closest('[data-samples-close]')) { closeModal(); return; }
    var btn = e.target.closest('.samples__btn');
    if (btn) { e.preventDefault(); addSample(btn); }
  });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeModal(); });

  async function addSample(btn) {
    if (btn.disabled) return;
    var modal = getModal();
    var errorEl = modal && modal.querySelector('.samples--error-message');
    if (errorEl) errorEl.hidden = true;

    // Free-sample cap (0 = disabled): block adding another free sample once the
    // cart already holds `limit` free samples in total (any mix allowed up to it).
    var limit = sampleLimit();
    if (limit > 0 && btn.classList.contains('samples__btn--free')) {
      try {
        var cart = await fetch(cartUrl() + '.js').then(function (r) { return r.json(); });
        var freeCount = (cart.items || []).reduce(function (n, i) { return isFreeSample(i) ? n + (i.quantity || 0) : n; }, 0);
        if (freeCount >= limit) {
          showError(errorEl, 'You have reached your free sample limit (' + limit + ').');
          return;
        }
      } catch (e) { /* if the cart can't be read, don't block the add */ }
    }

    // Add via the theme's native cart flow.
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', btn.dataset.variantId);
    formData.append('quantity', 1);
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      formData.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      if (typeof cartEl.setActiveElement === 'function') cartEl.setActiveElement(btn);
    }
    config.body = formData;

    try {
      var response = await fetch(routes.cart_add_url, config).then(function (r) { return r.json(); });
      if (response.status) { showError(errorEl, response.description || response.message || 'Could not add sample.'); return; }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'samples', productVariantId: btn.dataset.variantId, cartData: response });
      }
      if (cartEl && typeof cartEl.renderContents === 'function') cartEl.renderContents(response);
      else window.location = cartUrl();
      closeModal();
    } catch (err) {
      console.error('Sample add to cart failed', err);
      showError(errorEl, 'Could not add sample.');
    }
  }

  // Reduce a cart line to `qty` via the theme's native change flow.
  function changeLine(key, qty) {
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var fd = new FormData();
    fd.append('id', key);
    fd.append('quantity', qty);
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      fd.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    config.body = fd;
    fetch((window.routes && routes.cart_change_url) || '/cart/change', config)
      .then(function (r) { return r.json(); })
      .then(function (res) { if (cartEl && typeof cartEl.renderContents === 'function') cartEl.renderContents(res); })
      .catch(function () {});
  }

  // On any cart change: (a) dim this product's free sample if it's in the cart,
  // (b) enforce the total free-sample cap (covers the cart's own quantity stepper,
  // which the click-time check can't see). Any mix is allowed up to the limit.
  function syncFromCart() {
    fetch(cartUrl() + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];

        var freeBtn = document.querySelector('.samples__btn--free');
        if (freeBtn) {
          var sku = freeBtn.dataset.variantSku;
          document.body.classList.toggle('samplesMaxed', items.some(function (i) { return (i.sku || '') === sku; }));
        }

        var limit = sampleLimit();
        if (limit > 0) {
          var freeLines = items.filter(isFreeSample);
          var total = freeLines.reduce(function (n, i) { return n + (i.quantity || 0); }, 0);
          if (total > limit) {
            // Trim the excess off the largest free line (the one most likely just increased).
            freeLines.sort(function (a, b) { return b.quantity - a.quantity; });
            var line = freeLines[0];
            changeLine(line.key, Math.max(1, line.quantity - (total - limit)));
          }
        }
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncFromCart);
  }
  if (document.querySelector('.samples__btn') || document.body.classList.contains('template-cart')) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFromCart);
    else syncFromCart();
  }
})();
